import React from "react";
import turtle from "./img/turtle.jpg";
import {
  LoggedInUserErrorPageWrapper,
  LoggedInUserErrorPageTitle,
  LoggedInUserErrorPageText,
  LoggedInUserErrorPageImage,
} from "./styles/applicant-review-form-styles";

const LoggedInUserErrorPage = () => (
  <LoggedInUserErrorPageWrapper data-test-id="logged-in-user-error-page-wrapper">
    <LoggedInUserErrorPageTitle className="animated fadeIn delay-2">
      Nice try, but computer says no: <br /> sadly this page isn’t for you
    </LoggedInUserErrorPageTitle>
    <LoggedInUserErrorPageText
      className="animated fadeIn delay-3"
      data-test-id="logged-in-user-error-page-paragraph"
    >
      If you send your unique link to the candidate you placed, they will be
      able to leave you a review. However, our system has identified you’re a
      recruiter, not a candidate, hence you’re seeing this page. Anyway, while
      you’re here, so it’s not been a total waste of time, here’s a picture of a
      tortoise catching a frisbee. Enjoy.
    </LoggedInUserErrorPageText>
    <LoggedInUserErrorPageImage
      src={turtle}
      alt="Turtle"
      className="animated fadeIn delay-4"
      data-test-id="logged-in-user-error-page-image"
    />
    <LoggedInUserErrorPageText last className="animated fadeIn delay-5">
      If you&apos;re curious, the candidate will be reviewing you on
      communication, professionalism, application support and would they
      recommend you to a friend. They can also leave a brief comment for you.
    </LoggedInUserErrorPageText>
  </LoggedInUserErrorPageWrapper>
);

export default LoggedInUserErrorPage;
